import { Link } from 'react-router-dom';

import { Avatar, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import backIcon from '../containers/img/back_icon.svg';
import { DarkGreen, LightGray } from './Styles';

const BreadCrumbAvatar = withStyles({
  avatar: {
    border: `0.1rem solid ${DarkGreen}`,
    marginRight: '0.5rem',
    height: '2rem',
    width: '2rem',
  },
})(({ classes }) => (
  <Avatar
    src={backIcon}
    className={classes.avatar}
  />
));

const BreadCrumb = ({ primaryText, secondaryText, to }) => (
  <Link to={to} css={{ marginTop: '0.25rem', textDecoration: 'none' }}>
    <div css={{
      display: 'flex', paddingLeft: '1rem', paddingRight: '1rem', paddingBottom: '1rem', alignItems: 'center',
    }}
    >
      <BreadCrumbAvatar />
      <div css={{ display: 'flex', flexDirection: 'column' }}>
        <p css={{ color: DarkGreen, margin: '0px', fontSize: '0.8rem' }}>{primaryText}</p>
        {secondaryText && (<p css={{ color: LightGray, margin: '0px', fontSize: '0.7rem' }}>{secondaryText}</p>)}
      </div>
    </div>
    <Divider />
  </Link>
);

export default BreadCrumb;
